export default function isRequired(value) {
  return value !== null && value !== undefined && value !== "";
}
